var React = require('react');

function Arrowblueright (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.933 0V10.6226H0V13.4743H25.7996V6.51141L31.8434 12.096L22.933 20.9601V25L36 12.0247L22.933 0Z","fill":"#4285F4"}));
}

Arrowblueright.defaultProps = {"width":"36","height":"25","viewBox":"0 0 36 25","fill":"none"};

module.exports = Arrowblueright;

Arrowblueright.default = Arrowblueright;
